import { Injectable } from '@angular/core'
import { Observable, ReplaySubject, delay, filter, map } from 'rxjs'
import { NavigationEvent, Statistics } from '../types'
import { UserService } from './user.service'
import { NavigationEnd, Router } from '@angular/router'
import { ResearchService } from './research.service'

@Injectable({
   providedIn: 'root'
})
export class StatisticsService {

   statistics: ReplaySubject<Statistics> = new ReplaySubject<Statistics>()

   onEvent() {
      return this.statistics.asObservable()
   }

   constructor(private user: UserService, private router: Router, private research: ResearchService) { }

   initialize() {
      this.trackNavigation().subscribe((event) => {
         this.pageView(event.url)
      })
   }

   trackNavigation(): Observable<NavigationEvent> {
      return this.router.events.pipe(
         filter((event): event is NavigationEnd => event instanceof NavigationEnd),
         map((e: NavigationEnd) => {
            return { url: e.urlAfterRedirects }
         }),
         delay(0),
      )
   }

   pageView(url: string, label = 'url') {
      return this.sendEvent({
         action: 'pageView',
         category: 'navigation',
         label: label,
         value: url,
         question: this.research?.qandas[this.research?.qandas?.length -1]?.question ?? null
      })
   }

   sendEvent(event: Statistics, date = new Date()) {
      event.date = date
      event.session = this.research.currentResearchSessionId
      this.statistics.next(event)
   }

   search(question: string, source = 'inputbox') {
      this.sendEvent({
         action: source,
         category: 'search',
         label: 'question',
         value: question,
         question: question
      })
   }
}
